import { useEffect, useRef, useState } from "react";

export const useDepartmentPanelResize = (
  initialWidth = 320,
  initialHeight = 500
) => {
  const [panelWidth, setPanelWidth] = useState(initialWidth);
  const [panelHeight, setPanelHeight] = useState(initialHeight);
  const [isResizing, setIsResizing] = useState(false);
  const [isResizingHeight, setIsResizingHeight] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (isResizing && panelRef.current) {
        const rect = panelRef.current.getBoundingClientRect();
        // Calculate new width based on panel's actual right edge position
        const newWidth = rect.right - e.clientX;
        setPanelWidth(
          Math.max(280, Math.min(newWidth, window.innerWidth - 40))
        );
      }
      if (isResizingHeight && panelRef.current) {
        const rect = panelRef.current.getBoundingClientRect();
        const newHeight = e.clientY - rect.top;
        setPanelHeight(
          Math.max(300, Math.min(newHeight, window.innerHeight - 40))
        );
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      setIsResizingHeight(false);
    };

    if (isResizing || isResizingHeight) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing, isResizingHeight]);

  return {
    panelWidth,
    panelHeight,
    panelRef,
    setIsResizing,
    setIsResizingHeight,
  };
};
